import { styled } from "styled-components";

import { Grid, Text } from "@vericus/cadmus-ui";

/**
 * Date column min is pinned to the `DateCalendar` content width. A
 * two-month card is 2×360 (grid) + 36 (gap) + 40 (card padding) = 796px,
 * plus this column's own 36px padding-right = **832px**. Below that the
 * grid wraps so the calendar gets the full row to itself.
 */
export const DateTimeGrid = styled(Grid)`
  grid-template-columns: minmax(832px, 5fr) minmax(0, 3fr);
  grid-template-areas: "date time";
  grid-row-gap: 45px;

  @media screen and (max-width: 945px) {
    grid-template-columns: 1fr;
    grid-template-areas:
      "date"
      "time";
  }
`;

export const GridDate = styled.div`
  grid-area: date;
  padding-right: 36px;
`;

export const GridTime = styled.div`
  grid-area: time;
`;

export const HeadingGrid = styled(Grid)`
  grid-template-areas:
    "title title title title title title title title title"
    "lead lead lead lead lead lead lead lead lead";
`;

export const GridTitle = styled(Text)`
  grid-area: title;
`;

export const GridLead = styled(Text)`
  grid-area: lead;
`;

export const Footer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
